import React, { Component } from "react";
import axios from "axios";
import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Card, Grid, TextField } from "@mui/material";
import { Navigate } from "react-router-dom";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import MediaPickerModal from "Main/Modals/MediaModal";

export default class UpdateLevel extends Component {
  state = {
    id: null,
    title: "",
    sub_title: "",
    role_id: "",
    description: "",
    specification: "",
    selectedImage: null,
    showMediaModal: false,
    img_alt_text: "",
    meta_key: "",
    meta_description: "",
    notification: false,
    message: "",
    redirect: false,
    loading: false,
  };

  componentDidMount() {
    this.getLevelDetails();
  }

  getId = () => {
    return window.location.pathname.split("/")[2];
  };

  // 🔥 Fetch Single Level
  getLevelDetails = async () => {
    try {
      const id = this.getId();

      if (init() === "success") {
        const resp = await axios.post(Constants.getUrls.getSingleLevel, { id });

        console.log(resp);

        const data = resp.data.data;

        this.setState({
          id: data.id,
          title: data.title,
          sub_title: data.sub_title,
          role_id: data.role_id,
          description: data.description,
          specification: data.specification,
          selectedImage: {
            id: data.image_id,
            image_path: data.image_path,
          },
          img_alt_text: data.img_alt_text,
          meta_key: data.meta_key,
          meta_description: data.meta_description,
        });
      } else {
        window.location.assign("/signin");
      }
    } catch (err) {
      console.log(err);
    }
  };

  handleInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleDescription = (e) => {
    this.setState({ description: e.target.value });
  };

  handleSpecification = (content) => {
    this.setState({ specification: content });
  };

  // 🔥 Update Submit
  handleSubmit = async (e) => {
    e.preventDefault();

    const {
      id,
      title,
      sub_title,
      role_id,
      description,
      specification,
      selectedImage,
      img_alt_text,
      meta_key,
      meta_description,
    } = this.state;

    if (!selectedImage) {
      return this.setState({
        notification: true,
        message: "Please select an image",
      });
    }

    const payload = {
      id,
      title,
      sub_title,
      role_id,
      description,
      specification,
      image_id: selectedImage.id,
      img_alt_text,
      meta_key,
      meta_description,
    };

    console.log(payload);
    

    try {
      if (init() === "success") {
        this.setState({ loading: true });

        const resp = await axios.post(Constants.putUrls.updateLevel, payload);

        this.setState({
          notification: true,
          message: resp.data.message || "Updated successfully!",
          loading: false,
        });

        setTimeout(() => {
          this.setState({ redirect: true });
        }, 2000);
      } else {
        window.location.assign("/signin");
      }
    } catch (err) {
      console.log(err);

      this.setState({
        notification: true,
        message: err?.response?.data?.message || "Something went wrong!",
        loading: false,
      });
    }
  };

  render() {
    if (this.state.redirect) {
      return <Navigate to="/levels" />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              bgColor="info"
              borderRadius="lg"
            >
              <MDTypography variant="h6" color="white">
                Update Level
              </MDTypography>
            </MDBox>

            <MDBox py={3} px={2}>
              <form onSubmit={this.handleSubmit}>
                <Grid container spacing={2}>
                  {/* Title */}
                  <Grid item sm={6}>
                    <TextField
                      label="Title"
                      name="title"
                      value={this.state.title}
                      onChange={this.handleInput}
                      fullWidth
                    />
                  </Grid>

                  {/* Sub Title */}
                  <Grid item sm={6}>
                    <TextField
                      label="Sub Title"
                      name="sub_title"
                      value={this.state.sub_title}
                      onChange={this.handleInput}
                      fullWidth
                    />
                  </Grid>

                  {/* Image Picker */}
                  <Grid item sm={6}>
                    <MDButton
                      variant="contained"
                      color="info"
                      onClick={() => this.setState({ showMediaModal: true })}
                    >
                      Change Image
                    </MDButton>

                    {this.state.selectedImage && (
                      <img
                        src={
                          Constants.imageDomain +
                          this.state.selectedImage.image_path
                        }
                        style={{
                          width: 80,
                          height: 80,
                          marginTop: 10,
                        }}
                      />
                    )}
                  </Grid>

                  <Grid item sm={6}>
                    <TextField
                      label="Image Text"
                      name="img_alt_text"
                      value={this.state.img_alt_text}
                      onChange={this.handleInput}
                      fullWidth
                    />
                  </Grid>

                  <Grid item sm={6}>
                    <TextField
                      label="Meta Key"
                      name="meta_key"
                      value={this.state.meta_key}
                      onChange={this.handleInput}
                      fullWidth
                    />
                  </Grid>

                  <Grid item sm={12}>
                    <TextField
                      label="Meta Description"
                      name="meta_description"
                      multiline
                      rows={4}
                      value={this.state.meta_description}
                      onChange={this.handleInput}
                      fullWidth
                    />
                  </Grid>

                  {/* Description */}
                  <Grid item sm={12}>
                    <TextField
                      label="Description"
                      multiline
                      rows={4}
                      value={this.state.description}
                      onChange={this.handleDescription}
                      fullWidth
                    />
                  </Grid>

                  {/* Specification */}
                  <Grid item sm={12}>
                    <SunEditor
                      height={150}
                      setOptions={{
                        buttonList: [
                          ["undo", "redo"],
                          ["font", "fontSize"],
                          ["paragraphStyle", "blockquote"],
                          [
                            "bold",
                            "underline",
                            "italic",
                            "strike",
                            "subscript",
                            "superscript",
                          ],
                          ["fontColor", "hiliteColor"],
                          ["align", "list", "lineHeight"],
                          ["outdent", "indent"],

                          ["table", "horizontalRule", "link", "image", "video"],
                          // ['math'] //You must add the 'katex' library at options to use the 'math' plugin.
                          ["imageGallery"], // You must add the "imageGalleryUrl".
                          // ["fullScreen", "showBlocks", "codeView"],
                          ["preview", "print"],
                          ["removeFormat"],

                          // ["save", "template"],
                          // '/', Line break
                        ], // Or Array of button list, eg. [['font', 'align'], ['image']]
                        defaultTag: "div",
                        height: 120,
                        showPathLabel: false,
                        // font: sortedFontOptions
                      }}
                      setContents={this.state.specification}
                      onChange={this.handleSpecification}
                    />
                  </Grid>
                </Grid>

                <Grid mt={2}>
                  <MDButton variant="contained" color="info" type="submit">
                    {this.state.loading ? "Updating..." : "Update Level"}
                  </MDButton>
                </Grid>
              </form>
            </MDBox>

            <MDSnackbar
              color="success"
              title="Level"
              content={this.state.message}
              open={this.state.notification}
            />

            {/* Media Modal */}
            <MediaPickerModal
              visible={this.state.showMediaModal}
              multiple={false}
              onClose={() => this.setState({ showMediaModal: false })}
              onSelect={(images) => {
                this.setState({
                  selectedImage: images[0],
                  showMediaModal: false,
                });
              }}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
